
import { computed, defineComponent, PropType, ref } from 'vue'
import { usePackageModule } from '@/modules/packages'

export default defineComponent({
    name: 'form-field-packages',
    props: {
        modelValue: {
            type: Array as PropType<string[]>,
            required: true
        },
        hideInactives: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        const { packages } = usePackageModule()

        const packagesOptions = computed(() => {
            let filtered = [...packages.value]
            if (props.hideInactives) {
                filtered = packages.value.filter(item => item.status !== 'inactive')
            }
            return filtered.map(packageItem => {
                return {
                    label: packageItem.name,
                    value: packageItem.id,
                    selected: localModel.value.includes(packageItem.id)
                }
            })
        })

        const showOnlySelectedPackages = ref<boolean>(false)
        const filter = ref<string>('')

        const filteredPackages = computed(() => {
            let result = []
            if (filter.value === null || filter.value === '') {
                result = packagesOptions.value
            }

            const regexp = new RegExp(filter.value, 'i')
            result = packagesOptions.value.filter(item => regexp.test(item.label))
            if (showOnlySelectedPackages.value) {
                return result.filter(item => item.selected)
            }

            return result
        })

        return {
            localModel,
            filter,
            filteredPackages,
            packagesOptions,
            showOnlySelectedPackages
        }
    }
})
